import { CatalogState } from './state';

export const catalogInitialState: CatalogState = {
  releases: {
    items: [],
    nextToken: null,
  },
  collaborator: {
    items: [],
    nextToken: null,
  },
  master: {
    items: [],
    nextToken: null,
  },
  publishing: {
    items: [],
    nextToken: null,
  },
  sorting: 'default',
};
